import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import optionTypes from '../../../constants/option-types';
import previewGifs from '../constants/preview-gifs';
import computeBorderRadiusFallback from '../helpers/compute-border-radius-fallback';

const { Paragraph, Icon } = designSystem;

const SLIDER_MIN = 0;
const SLIDER_MAX = 128;
const SLIDER_STEP = 1;

const BORDER_RADIUSES = {
  topLeft: {
    id: 'top-left-corner',
    attributes: ['border-top-left-radius'],
    iconGlyph: 'corner-top-left-radius',
  },
  topRight: {
    id: 'top-right-corner',
    attributes: ['border-top-right-radius'],
    iconGlyph: 'corner-top-right-radius',
  },
  bottomLeft: {
    id: 'bottom-left-corner',
    attributes: ['border-bottom-left-radius'],
    iconGlyph: 'corner-bottom-left-radius',
  },
  bottomRight: {
    id: 'bottom-right-corner',
    attributes: ['border-bottom-right-radius'],
    iconGlyph: 'corner-bottom-right-radius',
  },
};

const getPopoverProps = ({ imgSrc, iconGlyph }) => ({
  imgSrc,
  renderContent: () => (
    <Paragraph appearance="white" size="small">
      {i18next.t('Adjust corners for columns')}. {i18next.t('Click the {icon}', { icon: '' })}{' '}
      <Icon type="white" size={16} strokeWidth={2} glyph={iconGlyph} insideText />
      {i18next.t('{click_the_icon} to adjust each one separately', { click_the_icon: '' })}
    </Paragraph>
  ),
});

const getBorderRadiuses = (settings = {}) => ({
  ...settings,
  id: 'all-corners',
  type: optionTypes.SLIDER,
  title: i18next.t('Independent corners'),
  computeFallbackValue: computeBorderRadiusFallback,
  iconGlyph: 'corner-radius',
  mixedLabel: i18next.t('Mixed'),
  step: SLIDER_STEP,
  min: SLIDER_MIN,
  max: SLIDER_MAX,
  popover: getPopoverProps({
    imgSrc: previewGifs.COLUMN_CORNERS_GIF,
    iconGlyph: 'corner-radius',
  }),
  options: Object.values(BORDER_RADIUSES).map((subOption) => ({
    ...settings,
    ...subOption,
    type: optionTypes.SLIDER,
    computeFallbackValue: computeBorderRadiusFallback,
  })),
});

export default getBorderRadiuses;
export { BORDER_RADIUSES };
